import { faCode } from '@fortawesome/free-solid-svg-icons'
import type { FC } from 'react'
import { useState } from 'react'

import DeveloperPanel from '@/components/DeveloperPanel/Sidebar'
import IconButton from '@/components/IconButton'
import type { SupportContact } from '@/lib/apollo/query/get-applicant'

interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  supportContacts?: SupportContact[]
}

const Developer: FC<Props> = ({
  customerId,
  applicationId,
  subjectId,
  supportContacts,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <DeveloperPanel
          subjectId={subjectId}
          customerId={customerId}
          applicationId={applicationId}
          supportContacts={supportContacts}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <IconButton
        tooltipMessage="Developer tools"
        icon={faCode}
        onClick={() => setIsSidebarOpen(true)}
      />
    </>
  )
}

export default Developer
